module.exports = __webpack_public_path__ + "static/media/tata_logo.522dfe51.png";